/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/11/22, 3:15 PM
 *
 */

import MemberTestTab from 'features/members/components/tabs/MemberTestTab/MemberTestTab';

export default MemberTestTab;
